<template>
    <div>
        <loading :active.sync="loadingContent" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Layanan Bantuan</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" v-if="loadingContent == false">
            <ul class="listview image-listview inset m-2">
                <li v-for="item in care_center" :key="item.id">
                    <a href="#" class="item">
                        <div class="icon-box bg-primary">
                            <ion-icon name="logo-whatsapp"></ion-icon>
                        </div>
                        <div class="in">

                            <div>
                                {{ item.name }}
                                <footer>{{ item.id_number }}</footer>
                            </div>
                            <a :href="item.url_redirect" target="_blank" class="btn btn-primary btn-sm">Hubungi</a>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="section mt-2 mb-2">
                <div class="card">
                    <div class="card-body">
                        <div class="p-1">
                            <div class="text-center">
                                <h2 class="text-primary mb-2">Media Sosial</h2>

                                <a href="https://web.facebook.com/qiosfincom" target="_blank" class="btn btn-facebook btn-icon mr-05">
                                    <ion-icon name="logo-facebook"></ion-icon>
                                </a>

                                <a href="http://tanya.web.id/tanya-difa" target="_blank" class="btn btn-whatsapp btn-icon mr-05">
                                    <ion-icon name="logo-whatsapp"></ion-icon>
                                </a>

                                <a href="https://www.instagram.com/qiosfincom/" target="_blank" class="btn btn-instagram btn-icon mr-05">
                                    <ion-icon name="logo-instagram"></ion-icon>
                                </a>

                                <a href="https://t.me/qiosfincom/" target="_blank" class="btn btn-primary btn-icon mr-05">
                                    <ion-icon name="paper-plane"></ion-icon>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $axios from './../api.js'
export default {
   data() {
       return {
           loadingContent: true,
           care_center: []
       }
   },
   created() {
       this.getCareCcenter()
   },
   methods: {
        getCareCcenter(){
            $axios.get('/care-center')
            .then((response) => {
                this.care_center = response.data.data
                this.loadingContent = false
            }).catch(() => {
                this.loadingContent = false
            })
       }
    },
    mounted(){
        document.body.classList.remove('bg-white')
    },
}
</script>